
































import { defineComponent, ref, watch } from '@vue/composition-api';
import { debounce } from '@/bundles/App/helpers';
import { useActivityGroup } from '@/bundles/ActivityGroup/composables/useActivityGroup';
import { ActivityGroupType } from '@/bundles/ActivityGroup/types';
import { useVoiceClass } from '@/bundles/VideoContent/composables/useVoiceClass';

export default defineComponent({
  name: 'LoadVoiceClassesForm',
  emits: ['list:refresh'],

  setup(_, {emit}) {
    const {loading: voiceClassesLoading, voiceClasses, fetchVoiceClasses: fetch} = useVoiceClass();

    const voiceKeyword = ref('');
    const selected = ref(null);

    function keywordSearch() {
      if (!voiceKeyword.value?.length) {
        return fetch({});
      }
      fetch({keyword: voiceKeyword.value});
    }

    const searchWrapper = debounce(keywordSearch, 500);
    watch(voiceKeyword, () => {
      searchWrapper();
    });

    const {addToGroup, addToGroupLoading} = useActivityGroup();

    async function submitEventHandler() {
      if (!selected.value) {
        return;
      }
      await addToGroup(ActivityGroupType.voice_class, {record_id: selected.value!});
      clearForm();
      emit('list:refresh');
    }

    function clearForm() {
      selected.value = null;
      voiceKeyword.value = '';
    }

    return {
      voiceKeyword,
      selected,
      voiceClasses,
      addToGroupLoading,
      voiceClassesLoading,
      submitEventHandler,
    };
  },
});
